import "reflect-metadata";
import {Container, interfaces} from "inversify";
import SERVICE_IDENTIFIER from "./identifiers";
import {Application} from "../application/application";
import {Service} from "../interface/service";
import {ComponentService} from "../service/component";
import {Component} from "../interface/component";

let container = new Container();
container.bind<Application>(SERVICE_IDENTIFIER.APPLICATION).to(Application);
container.bind<Service>(SERVICE_IDENTIFIER.COMPONENTS).toConstantValue(new ComponentService());
container.bind<interfaces.Factory<Component>>("Factory<Component>").toFactory<Component>((context) => {
    return (named: string) => (element: HTMLElement) => {
        let component = context.container.getNamed<Component>(SERVICE_IDENTIFIER.COMPONENT, named);
        component.init(element);
        return component;
    };
});
export default container;